import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import "@fontsource/roboto/500.css";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from '@mui/material/ListItemIcon';
import { Button, IconButton, ListItem, ListItemButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import DrawerManager from "./DrawerManager";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateConfig } from "../app/configSlice";
import { useHistory } from "react-router-dom";
import Deploy from '../icons/Deploy.png';
import Event from '../icons/Event.png';
import Help from '../icons/Help.png';
import Local from '../icons/Local.png';
import Messages from '../icons/Messages.png';
import Misc from '../icons/Misc.png';
import Simulate from '../icons/Simulate.png';
import Logo from '../icons/Logo.png';
import Animation from '../icons/Animation.gif';

const drawerWidth = 240;

const featureList = [
  "Dynamic Messages",
  "Special Event",
  "Help",
  "Local Messages",
  "Misc",
];

const iconList = [
  Messages,
  Event,
  Help,
  Local,
  Misc,
];

function MainPage() {
  const [pageIndex, setPageIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [mobileOpen, setMobileOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const mainContentRef = React.useRef(null);
  const theme = useTheme();
  // below this width the permanent sidebar can no longer fit without horizontal scrolling (WCAG 1.4.10 reflow)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    console.log("use effect test");
    dispatch(updateConfig());
  }, []);

  useEffect(() => {
    mainContentRef.current?.focus();
  }, [pageIndex]);

  const handleClick = (index) => {
    console.log("this is the index ", index);
    setSelectedIndex(index);
    setPageIndex(index);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex"}}>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded"
      >
        Skip to main content
      </a>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar disableGutters sx={{ flexWrap: "wrap" }}>
          <IconButton
            color="inherit"
            aria-label="Toggle navigation menu"
            aria-expanded={mobileOpen}
            onClick={handleDrawerToggle}
            sx={{ display: isMobile ? "inline-flex" : "none", ml: 1 }}
          >
            <MenuIcon />
          </IconButton>
          <Box component="img" src={Animation} alt="" aria-hidden="true" sx={{ width: 90, display: isMobile ? "none" : "inline" }}></Box>
          <Box component="img" src={Logo} alt="VP Config logo" sx={{ width: isMobile ? 120 : 190 }}></Box>
          <Box sx={{ flexGrow: 1 }}>
          </Box>
          <Box>
            <Button
              sx={{ color: "white" }}
              variant="outlined"
              onClick={() => {
                localStorage.clear();
                history.push("/login");
              }}
            >
              Log out
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        role="navigation"
        aria-label="Main navigation"
        sx={{
          width: isMobile ? "auto" : drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <List>
            {featureList.map((text, index) => (
              <ListItem disablePadding key={text}>
                <ListItemButton
                  className = "drawerItem"
                  selected={selectedIndex === index}
                  sx={{
                    "&.Mui-selected": {
                      background: "#f5f5f5",
                      color: "#1876D1",
                    },
                  }}
                  onClick={() => {
                    handleClick(index);
                  }}
                >
                  <ListItemIcon>
                    <img src={iconList[index]} width="50%" alt="" aria-hidden="true"></img>
                  </ListItemIcon>
                  <ListItemText primary={text} sx={{ margin: -2.5 }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            <ListItem disablePadding key="Simulate">
              <ListItemButton
                selected={selectedIndex === 98}
                sx={{
                  "&.Mui-selected": {
                    background: "#f5f5f5",
                    color: "#1876D1",
                  },
                }}
                onClick={() => {
                  handleClick(98);
                }}
              >
                <ListItemIcon>
                  <img src={Simulate} width="50%" alt="" aria-hidden="true"></img>
                </ListItemIcon>
                <ListItemText primary="Simulate" sx={{ margin: -2.5 }} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding key="Deployment">
              <ListItemButton
                selected={selectedIndex === 99}
                sx={{
                  "&.Mui-selected": {
                    background: "#f5f5f5",
                    color: "#1876D1",
                  },
                }}
                onClick={() => {
                  handleClick(99);
                }}
              >
                <ListItemIcon>
                  <img src={Deploy} width="50%" alt="" aria-hidden="true"></img>
                </ListItemIcon>
                <ListItemText primary="Deployment" sx={{ margin: -2.5 }} />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      <Box>

      </Box>
      <Box component="main" role="main" id="main-content" ref={mainContentRef} tabIndex={-1} sx={{ flexGrow: 1, minWidth: 0, p: 3, backgroundColor: "#f5f5f5", minHeight:"100vh", outline: "none"}} >
        <Toolbar />
        <DrawerManager page={pageIndex} />
      </Box>
    </Box>
  );
}

export default MainPage;
